import { Grid } from '@mui/material'
import RemoveIcon from '@mui/icons-material/Close'
import { MobileDatePicker } from '@mui/x-date-pickers'
import { useContext } from 'react'
import { UseFieldArrayRemove } from 'react-hook-form'

import { leavingReasons, occupations } from '../../../../data'
import { SelectRegistered, TextFieldRegistered } from '../../Components'
import { FormContext } from '../../Contexts'

export const JobBlock = ({ index, remove }: { index: number; remove: UseFieldArrayRemove }) => {
  const { register, setValue, watch } = useContext(FormContext)

  return (
    <Grid item rowSpacing={2} style={{ backgroundColor: '#1976d214', padding: 10, borderRadius: 10, marginTop: 10 }}>
      <Grid container item>
        <Grid item xs={12} sm={6} md={6} order={{ xs: 2, sm: 1 }}>
          <TextFieldRegistered required name={`jobs.${index}.company`} label="Empresa" />
        </Grid>
        <Grid item xs={12} sm={6} md={6} flex={1} textAlign={'right'} order={{ xs: 1, sm: 2 }}>
          <RemoveIcon onClick={() => remove(index)} style={{ cursor: 'pointer' }} />
        </Grid>
      </Grid>
      <Grid container item>
        <Grid item xs={12} sm={6} md={3}>
          <MobileDatePicker
            label="Fecha de Ingreso"
            views={['year', 'month']}
            format="MM/yyyy"
            disableFuture={true}
            openTo="month"
            closeOnSelect={true}
            slotProps={{
              actionBar: {
                actions: ['clear'],
              },
              textField: {
                variant: 'standard',
                fullWidth: true,
              },
            }}
            {...(register ? register(`jobs.${index}.entryDate`) : {})}
            value={watch && watch(`jobs.${index}.entryDate`)}
            onChange={(value) => setValue?.(`jobs.${index}.entryDate`, value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MobileDatePicker
            label="Fecha de Salida"
            views={['year', 'month']}
            format="MM/yyyy"
            disableFuture={true}
            openTo="month"
            closeOnSelect={true}
            slotProps={{
              actionBar: {
                actions: ['clear'],
              },
              textField: {
                variant: 'standard',
                fullWidth: true,
                required: false,
              },
            }}
            {...(register ? register(`jobs.${index}.leaveDate`) : {})}
            value={watch && watch(`jobs.${index}.leaveDate`)}
            onChange={(value) => setValue?.(`jobs.${index}.leaveDate`, value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <SelectRegistered
            name={`jobs.${index}.reasonLeaving`}
            label="Motivo de la salida"
            options={leavingReasons.map((reason) => ({ label: reason }))}
          />
        </Grid>
        {[...new Array(3)].map((_value, indexOccupation) => (
          <Grid container item xs={12} sm={12} md={12} key={`jobs.${index}.occupations.${indexOccupation}`}>
            <Grid item xs={12} sm={6} md={6}>
              <SelectRegistered
                name={`jobs.${index}.occupations.${indexOccupation}.occupation`}
                label={`Ocupación ${indexOccupation + 1}`}
                options={[
                  { label: `Ocupación ${indexOccupation + 1}` },
                  ...occupations.map((occupation) => ({ label: occupation })),
                  { label: 'Otro' },
                ]}
              />
            </Grid>
            {watch && watch(`jobs.${index}.occupations.${indexOccupation}.occupation`) === 'Otro' && (
              <Grid item xs={12} sm={6} md={6}>
                <TextFieldRegistered
                  name={`jobs.${index}.occupations.${indexOccupation}.otro`}
                  label={`Ocupación ${indexOccupation + 1}`}
                />
              </Grid>
            )}
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}
